export default __webpack_public_path__ + "static/media/Roxie_9781408331538.668015c6.jpg";